import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  AuthReducer,
  DossierReducer,
  MeldingenReducer,
  MetadataReducer,
  SearchReducer,
  StepperReducer,
  ToastReducer,
  VerwerkingsoverzichtReducer,
} from "./reducers";

const rootReducer = combineReducers({
  auth: AuthReducer,
  melding: MeldingenReducer,
  toast: ToastReducer,
  meta: MetadataReducer,
  dossier: DossierReducer,
  search: SearchReducer,
  stepper: StepperReducer,
  verwerkingsoverzicht: VerwerkingsoverzichtReducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
